import React, { useEffect, useState } from "react";
import AuthService from "services/auth.service";
import Avatar from "components/Avatar";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Table,
  Row,
  Col,
} from "reactstrap";

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const getLightVariant = (color) => {
  const lightenFactor = 0.7; // Adjust this factor as needed
  return color.replace(
    /^#/,
    (match) =>
      "#" +
      match
        .slice(1)
        .replace(/../g, (color) =>
          (
            "0" +
            Math.min(255, parseInt(color, 16) * lightenFactor).toString(16)
          ).slice(-2)
        )
  );
};

const TransactionItem = ({ title, totalFee, refundableFee, status }) => {
  const firstLetter = title.charAt(0).toUpperCase();
  const textColor = "#333"; // Dark text color
  const bgColor = getRandomColor();
  const lightBgColor = getLightVariant(bgColor);

  const roundImageStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: bgColor,
    color: "white",
    display: "inline-flex", // Display as inline-flex to have them side by side
    alignItems: "center",
    justifyContent: "center",
    padding: "5px", // Add padding for better spacing
    marginRight: "10px",
  };

  const textStyle = {
    // background: `linear-gradient(90deg, ${lightBgColor} 100%, transparent 100%)`,
    padding: "10px",
    borderRadius: "5px",
    color: "#222", // Dark text color
  };

  return (
    <td className="text-title">
      <div className="box-box">
        <div style={roundImageStyle} className="ball-mob">
          {firstLetter}
        </div>
      </div>
      <span style={textStyle} className="box-text">
        {title}
      </span>
    </td>
  );
};

function Tables() {
  const currentUser = AuthService.getCurrentUser();
  const id = currentUser.id;
  const [transaction, setTransaction] = useState([]);
  const [filter, setFilter] = useState("all");

  

  const retrieveTransaction = () => {
    AuthService.getAllTransaction(id)
      .then((response) => {
       // Sort transactions by date (newest first)
       const sortedTransactions = response.data.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      setTransaction(sortedTransactions);
    })
    .catch((e) => {
      console.log(e);
    });
};

useEffect(() => {
  // Fetch data immediately on mount
  retrieveTransaction();
  
  // Set up interval to fetch data every 10 seconds
  const intervalId = setInterval(retrieveTransaction, 20000);
  
  // Clean up interval on unmount
  return () => clearInterval(intervalId);
}, []);



  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: 'numeric', month: 'short' }; // Using 'short' to get abbreviated month names
    return date.toLocaleDateString('en-US', options);
  };



  const filteredTransactions = transaction.filter((item) => {
    if (filter === 'all') return true;
    return filter === 'paid' ? item.status : !item.status;
  });




  return (
    <>
      <div className="content tran-web">
        <Row>
          <Col md="12">
            <Card className="outer-line">
              <CardHeader className="space-it">
                <CardTitle tag="h4">Transactions</CardTitle>
                <div className="filt-web">
                  <Label for="statusFilter">Filter by Status</Label>
                  <Input
                    type="select"
                    name="statusFilter"
                    id="statusFilter"
                    value={filter}
                    onChange={handleFilterChange}
                  >
                    <option value="all">All</option>
                    <option value="paid">Paid</option>
                    <option value="pending">Pending</option>
                  </Input>
                </div>
              </CardHeader>
              <CardBody className="Nobar">
                <Table responsive>
                  <thead className="text-primary">
                    <tr className="table-head">
                      <th>Transaction</th>
                      <th>Total Fee Cost (Non Refundable)</th>
                      <th>Refundable Fee</th>
                      <th className="">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredTransactions.map((item, index) => (
                      <tr
                        key={item.id}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        {/* Use the new TransactionItem component */}
                        <TransactionItem
                          title={item.title}
                          totalFee={item.totalFee}
                          refundableFee={item.refundableFee}
                          status={item.status}
                        />
                        {/* <td className="text-title">{item.title}</td> */}
                        {/* <td>${parseFloat(item.totalFee).toFixed(2).toLocaleString()}</td> */}
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(item.totalFee))}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(item.refundableFee))}
                        </td>
                        <td className="text-status">
                          <div
                            className={`text-status-${
                              item.status ? "paid" : "pending"
                            }`}
                          >
                            {item.status ? "Paid" : "Pending"}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tbody></tbody>
                  <tfoot>
                    <tr className="table-head">
                      <th>Total </th>
                      <th>
                        {" "}
                        $
                        {parseFloat(
                          currentUser.transactionTotalFee
                        ).toLocaleString()}
                      </th>
                      <th>
                        {" "}
                        $
                        {parseFloat(
                          currentUser.transactionRefundableFee
                        ).toLocaleString()}
                      </th>
                      <th className=""></th>
                    </tr>
                  </tfoot>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {/* transaction for mob  */}

      <div className="jag-transaction-list tran-mob">
        <CardHeader>
          <CardTitle tag="h4"> All Transactions</CardTitle>
        </CardHeader>
        <FormGroup className="filt-mob">
                  <Label for="statusFilter">Filter by Status</Label>
                  <Input
                    type="select"
                    name="statusFilter"
                    id="statusFilter"
                    value={filter}
                    onChange={handleFilterChange}
                  >
                    <option value="all">All</option>
                    <option value="paid">Paid</option>
                    <option value="pending">Pending</option>
                  </Input>
                </FormGroup>
        <CardBody className="jag-tran-card">
          {filteredTransactions.map((transaction) => (
            <div key={transaction.id} className="jag-transaction-item">
              <div className="jag-transaction-info">
                <div className="jag-transaction-icon">
                  <Avatar text={transaction.title} />
                </div>
                <div>
                  <div className="jag-transaction-type">
                    {transaction.title}
                  </div>
                  <div className="jag-transaction-time">
                  {formatDate(transaction.createdAt)}
                  </div>
                </div>
              </div>
              <div className="jag-transaction-details">
                <div className="jag-transaction-amount">
                  +{new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(parseFloat(transaction.totalFee))}
                </div>
                <div className="jag-status" style={{ color: transaction.status ? "green" : "yellow" }}>
                  {transaction.status ? "Paid" : "Pending"}
                </div>
              </div>
            </div>
          ))}
        </CardBody>
      </div>
    </>
  );
}

export default Tables;
